module.exports = __webpack_public_path__ + "static/media/bg_with_flag01.2516630b.jpg";